// @flow

import _ from 'lodash';

import ArrayUtils from '../../utils/ArrayUtils';

import ApiObject from '../ApiObject';
import CreditCard from './CreditCard';

export default class CreditCardsList extends ApiObject {

  cards: Array<CreditCard> = [];

  postJsonAssignation(data: Object) {
    super.postJsonAssignation(data);

    // -- deserialize cards
    this.cards = [];
    const _this = this;

    // -- handle the case were the api responds a json with the array directly.
    let dataCreditCards = [];
    if (!_.isUndefined(data.cards)) {
      dataCreditCards = data.cards;
    } else {
      dataCreditCards = data;
    }

    _.each(dataCreditCards, (creditCardData: Object) => {
      const creditCard: CreditCard = new CreditCard();
      creditCard.fromJson(creditCardData);
      _this.cards.push(creditCard);
    });
  }


  findById(idToFind: string): ?CreditCard {
    const found = _.find(this.cards, (creditCard: CreditCard): boolean => {
      return creditCard.id === idToFind;
    });

    if (_.isUndefined(found)) {
      return null;
    }

    return found;
  }

  addCreditCard(creditCard: CreditCard) {
    this.cards.push(creditCard);
  }

  deleteCreditCard(creditCard: CreditCard) {
    this.cards = ArrayUtils.deleteObject(this.cards, { id: creditCard.id });
  }

  isEmpty(): boolean {
    return _.isEmpty(this.cards);
  }
}
